<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/finance-config/invoice-name-management">开票名称管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="选择Excel">
              <invoice-name-batch-excel
                @getDemo="getDemo"
                :xlsxReqHeader="xlsxReqHeader()"
                ref="invoiceNameExcel"
                @excelFileRemove="excelFileRemove"
                @change-file="(_) => this.file = _"
                @change="(_) => this.form.data = _"
              />
            </el-form-item>

            <el-form-item label="上传进度">
              <div style="margin-top: 8px">
                <el-progress v-if="percentage < 100"
                            :percentage="percentage"
                            :stroke-width="18"
                            color="#666666">
                </el-progress>
                <el-progress v-if="percentage === 100"
                            :percentage="100"
                            :stroke-width="18"
                            status="success">
                </el-progress>
              </div>
            </el-form-item>

            <el-form-item label="错误记录">
              <template>
                <div v-for="(item) in error_data">
                  <span>{{ item }}</span>
                </div>
              </template>
            </el-form-item>

          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">开始上传
          </el-button>
          <el-button @click="onReload">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import InvoiceNameBatchExcel from '../../components/InvoiceNameBatchExcel'

export default {
  components: {InvoiceNameBatchExcel},
  data () {
    return {
      form: {
        data: [],
      },
      error_data: [],
      percentage: 0,
      file: null,
      fileHeader: [],
    }
  },
  computed: {},
  watch: {},
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    ...request.map([]),
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$refs['form'].$refs['InvoiceNameBatchExcel'].clearFiles()
    },
    getFormData () {
      return _.cloneDeep(this.form.data)
    },
    onSubmit () {
      if (this.form.data.length === 0) {
        this.$message.error('请选择文件')
      } else {
        this.createOrUpdate()
      }
    },
    excelFileRemove (fileList) {
      if (fileList.length === 0) {
        this.form.data = []
      }
    },
    async createOrUpdate () {
      let data = this.getFormData()
      this.error_data = []
      for (let index = 0; index < data.length; index++) {
        let param = data[index]
        let num = index + 1
        this.percentage = (num / data.length) * 100

        let info = '第' + num + '行 '
        if (this.checkParams(param, info)) {
          try {
            if (this.$route.meta.type === 'batch_edit') {
              await request.loading('editInvoiceName', param)
            } else if (this.$route.meta.type === 'batch_create') {
              await request.loading('batchCreateInvoiceName', param)
            } else {
              this.error_data.push('路由错误')
              return false
            }
          } catch (error) {
            this.error_data.push(info + error.message)
          }
        }
      }
      if (this.error_data.length === 0) {
        this.$confirm('上传成功，是否返回列表查看', '提示', {type: 'warning'}).then(() => {
          this.$router.back()
        })
      }
    },
    checkParams (param, info) {
      let err = ''
      const reqHeader = this.xlsxReqHeader()
      for (const ruleKey in reqHeader) {
        if (param[ruleKey] === '') {
          err = reqHeader[ruleKey].text + ' 为空'
          break
        }
      }

      // 转换请求参数数值
      this.convertParamValue(param, info, err)

      if (err) {
        this.error_data.push(info + err)
        return false
      }
      return true
    },
    convertParamValue (param, info, err) {
      if (param.hasOwnProperty('tax_rate')) {
        param.tax_rate = param.tax_rate.toString().replace('%', '')
        if (param.tax_rate < 1) {
          param.tax_rate *= 100
        }
      }
      if (param.hasOwnProperty('is_disabled')) {
        if (param.is_disabled === '启用中') {
          param.is_disabled = 0
        } else if (param.is_disabled === '已禁用') {
          param.is_disabled = 1
        } else {
          err = '禁用状态仅支持输入【启用中】、【已禁用】'
        }
      }
    },
    // 返回 excel 文件必须存在的表头字段
    xlsxReqHeader () {
      if (this.$route.meta.type === 'batch_edit') {
        return {
          id: {index: null, text: '开票名称ID'},
          tax_rate: {index: null, text: '税率'},
          product_num: {index: null, text: '商品编码'},
          is_disabled: {index: null, text: '禁用状态'},
        }
      } else if (this.$route.meta.type === 'batch_create') {
        return {
          name: {index: null, text: '开票名称'},
          type_name: {index: null, text: '开票名称类别'},
          tax_rate: {index: null, text: '税率'},
          product_num: {index: null, text: '商品编码'},
        }
      }
      this.error_data = ['路由错误']
      return {}
    },
    getDemo () {
      if (this.$route.meta.type === 'batch_edit') {
        this.getUpdateDemo()
      } else if (this.$route.meta.type === 'batch_create') {
        this.getCreateDemo()
      } else {
        this.error_data = ['路由错误，无法下载 demo 文件']
      }
    },
    getCreateDemo () {
      let demo = [
        {'name': '其他服务费', type_name: '其他', tax_rate: '6%', product_num: '3049900000000000000'},
        {'name': '其他咨询服务费', type_name: '其他', tax_rate: '6%', product_num: '3049900000000000001'},
      ]
      this.$export('批量添加开票名称 Demo', demo, {fileHeader: this.getDemoHeader(this.xlsxReqHeader())})
    },
    getUpdateDemo () {
      let demo = [
        {id: 1, tax_rate: '6%', product_num: '3049900000000000000', is_disabled: '启用中'},
        {id: 2, tax_rate: '6%', product_num: '3049900000000000001', is_disabled: '启用中'},
      ]
      this.$export('批量更新开票名称 Demo', demo, {fileHeader: this.getDemoHeader(this.xlsxReqHeader())})
    },
    getDemoHeader (reqHeader) {
      let demoHeader = []
      for (const key in reqHeader) {
        if (reqHeader.hasOwnProperty(key) && reqHeader[key].hasOwnProperty('text')) {
          demoHeader.push({key, text: reqHeader[key].text})
        }
      }
      return demoHeader
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/finance-config/pages/invoice-name/FinanceInvoiceNameBatchForm.vue